"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightShipmentStatus = exports.FreightRequestOrigin = exports.FreightExternalShipmentProvider = exports.FreightStrategy = exports.FreightAccessorialLookup = void 0;
const stringEnum_1 = require("./stringEnum");
exports.FreightAccessorialLookup = (0, stringEnum_1.stringEnum)([
    "RESIDENTIAL_PICKUP",
    "LIFTGATE_PICKUP",
    "PICKUP_APPOINTMENT",
    "MILITARY_BASE_PICKUP",
    "AIRPORT_PICKUP",
    "DELIVERY_APPOINTMENT",
    "DELIVERY_NOTIFICATION",
    "LIFTGATE_DELIVERY",
    "MILITARY_BASE_DELIVERY",
    "AIRPORT_DELIVERY",
]);
var FreightStrategy;
(function (FreightStrategy) {
    FreightStrategy["LTL"] = "LTL";
    FreightStrategy["FTL"] = "FTL";
    FreightStrategy["TIME_GUARANTEED"] = "TIME_GUARANTEED";
    FreightStrategy["DRAYAGE"] = "DRAYAGE";
})(FreightStrategy = exports.FreightStrategy || (exports.FreightStrategy = {}));
var FreightExternalShipmentProvider;
(function (FreightExternalShipmentProvider) {
    FreightExternalShipmentProvider["GLOBALTRANZ"] = "GLOBALTRANZ";
    FreightExternalShipmentProvider["SHIPWELL"] = "SHIPWELL";
})(FreightExternalShipmentProvider = exports.FreightExternalShipmentProvider || (exports.FreightExternalShipmentProvider = {}));
var FreightRequestOrigin;
(function (FreightRequestOrigin) {
    FreightRequestOrigin["API"] = "API";
    FreightRequestOrigin["SHIPWELL_WEBHOOK"] = "SHIPWELL_WEBHOOK";
    FreightRequestOrigin["INBOUNDS"] = "INBOUNDS";
})(FreightRequestOrigin = exports.FreightRequestOrigin || (exports.FreightRequestOrigin = {}));
var FreightShipmentStatus;
(function (FreightShipmentStatus) {
    FreightShipmentStatus["CREATED"] = "CREATED";
    FreightShipmentStatus["DISPATCHED"] = "DISPATCHED";
    FreightShipmentStatus["AT_PICKUP"] = "AT_PICKUP";
    FreightShipmentStatus["IN_TRANSIT"] = "IN_TRANSIT";
    FreightShipmentStatus["AT_DELIVERY"] = "AT_DELIVERY";
    FreightShipmentStatus["ERROR"] = "ERROR";
    FreightShipmentStatus["CANCELLED"] = "CANCELLED";
    FreightShipmentStatus["COMPLETED"] = "COMPLETED";
    FreightShipmentStatus["AUTOCOMPLETED"] = "AUTOCOMPLETED";
    FreightShipmentStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
})(FreightShipmentStatus = exports.FreightShipmentStatus || (exports.FreightShipmentStatus = {}));
//# sourceMappingURL=FreightShipment.js.map